module.exports = __webpack_public_path__ + "img/kybernetwork.0346de19.png";